var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebookBlack = function SvgFacebookBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 18c0-9.941-8.059-18-18-18S0 8.059 0 18c0 8.984 6.582 16.431 15.188 17.781V23.203h-4.57V18h4.57v-3.966c0-4.51 2.687-7.003 6.798-7.003 1.97 0 4.03.352 4.03.352v4.43h-2.27c-2.236 0-2.933 1.387-2.933 2.812V18h4.992l-.798 5.203h-4.195v12.578C29.419 34.431 36 26.984 36 18Z",
    fill: "#191919"
  })));
};

export default SvgFacebookBlack;